/*
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2023-10-10 09:26:28
 * @LastEditors: whaoo
 * @LastEditTime: 2024-07-29 14:31:42
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import 'element-ui/lib/theme-chalk/index.css';
import http from './api/http.js'
import httpSync from './api/http_sync'
Vue.prototype.$http = http
Vue.prototype.$httpSync = httpSync
import date from '../static/date'
Vue.prototype.$dateFtt = date
Vue.config.productionTip = false
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import { Input, Message } from 'element-ui';
import { Dialog } from 'element-ui';
import { Table } from 'element-ui';
import { TableColumn } from 'element-ui';
import { Button } from 'element-ui';
import { Pagination } from 'element-ui';
import { MessageBox } from 'element-ui';
import { Select } from 'element-ui'
import { Option } from 'element-ui'
import { Form } from 'element-ui'
import { FormItem } from 'element-ui'
import { Switch } from 'element-ui'
import { Row, Col } from 'element-ui'
import { Menu, MenuItem } from 'element-ui'
import { DatePicker } from 'element-ui'
import { Checkbox } from 'element-ui'
import { TimePicker } from 'element-ui'
import { Radio } from 'element-ui'
import { Empty } from 'element-ui'

Vue.use(Empty)
Vue.use(TimePicker)
Vue.use(Checkbox)
Vue.use(DatePicker)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Switch)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(Dialog)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Button)
Vue.use(Pagination)
Vue.use(Input)
Vue.use(Radio)
import Md5 from 'js-md5'
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.md5Str = (str) => {
  return Md5(str.substring(str.length - 8, str.length)) + "xoJWeO24ZLU3xibLDv8aGaqN4M33Ee"
}
import { Loading } from 'element-ui';

Vue.use(Loading.directive);
import HighchartsVue from 'highcharts-vue'
// Vue.use(HighchartsVue)


/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
export default vm



// WEBPACK FOOTER //
// ./src/main.js